import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal, NgbActiveOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DetailsFeedComponent } from '../../../components/details-feed/details-feed.component';
import { SafeHtmlPipe } from '../../../shared/validators/safe-html.pipe';
import { LIMIT, MAX_SIZE } from '../../../utils/constants';
import { api } from '../../../utils/endpoints';
import { ICONS } from '../../../utils/svg-icons';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { ApiCallsService } from '../../services/network/api-calls.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-notification-popup',
  imports: [CommonModule, InfiniteScrollModule, SafeHtmlPipe],
  templateUrl: './notification-popup.component.html',
  styleUrl: './notification-popup.component.scss',
  providers: [NgbActiveModal], // ✅ Add provider here
})
export class NotificationPopupComponent {
  isPopupOpen = false;
  notificationLists: any = [];
  notificationCount: any;
  totalUnreadCount: any;
   ICONS = ICONS;
  @Output() closeEvent = new EventEmitter<void>();
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  constructor(
    private _userService: UserService,
    private _commonDataSharing: CommonDataSharingService,
    public activeOffcanvas: NgbActiveOffcanvas,
    private _apiService: ApiCallsService,
    private _ngbModal: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    this._userService.user.subscribe((user: any) => {
      if (user && user != null) {
        // this.userInfo = user ?? null;
        this.getNotification();
      }
    });
  }
  private getNotification(): void {
    this._commonDataSharing._getToggleNotification(this.pagination.limit, this.pagination.skip).subscribe({
      next: (res: any) => {
        if (res) {
          this.notificationLists=[]
          this.notificationCount = res.data.count || 0;
          res.data.rows.map((value: any) => {
            this.notificationLists.push(value);
          });
          this.totalUnreadCount = res.data.unreadNotificationsCount || 0;

          this.pagination.totalItems = res?.data.count;
          this.pagination.row = res?.data.rows.length;
          this.pagination.text = 'No record found!';
          this.cdr.detectChanges(); // Trigger re-render
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }
  openNotificationsPopup() {
    this.isPopupOpen = true;
  }
  onClose() {
    this.activeOffcanvas.close();
    this.closeEvent.emit();
  }

  closeNotificationsPopup() {
    this.isPopupOpen = false;
  }
  dateInMilisecond(date: any) {
    const d = new Date(date);
    const miliSecond = d.getTime();
    return miliSecond;
  }
  markAllAsRead(value: any): void {
    let notificationIds: any = [];
    if (value == 1) {
      this.notificationLists.map((item: any) => {
        if (!item.isRead) {
          notificationIds.push(item.id);
        }
      });
    } else {
      notificationIds.push(value.id);
    }
    this._commonDataSharing._markAllAsRead(notificationIds).subscribe({
      next: (res: any) => {
        this.pagination.skip = 0;
        this.notificationLists = [];
        this.getNotification();
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }
  onScroll(e: any) {
    if ((this.pagination.skip + 1) * 10 > this.pagination.totalItems || this.pagination.totalItems < 10) {
      return;
    }
    this.pagination.skip = this.pagination.skip + 1;
    this.getNotification();
  }
  getDetail(data: any) {
    if (data.notification.notificationType != 'welcome' && data.notification.postId != null) {
      this._apiService.get(api._FeedPost + '/' + data.notification.postId, {}).subscribe({
        next: (res: any) => {
          if (res) {
            this.onClose();
            let modalRef = this._ngbModal.open(DetailsFeedComponent, {
              backdrop: 'static',
              keyboard: false,
              size: 'galleryPopup',
              scrollable: false,
            });
            modalRef.componentInstance.query = { key: 'value', anotherKey: 'featuredFeed', usedFor: 'searchFeed' };
            // modalRef.componentInstance.buttonText='Assign Score'
            modalRef.componentInstance.data = res.data;
            modalRef.result.then((result: any) => {
              if (result) {
              }
            });
          }
        },
      });
    }
  }
  replaceText(value: any, notification: any) {
    return (value || '')?.replace('{username}', notification?.user?.alias || '-')?.replace('{feed}', notification?.post?.title || '-');
  }
}
